import { List } from './list';
import { VisitUiType } from 'store/visits/types';

export const AllVisitorsList = (): JSX.Element => <List type={VisitUiType.ALL} />;
